import Cookies from "js-cookie";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LOGIN_FAILIED_STYLE, NO_ROLE_ERR, COOKIE_KEY } from "../../utils/constants/GlobalConstants";


const NoRole = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const encryptF = Cookies.get(COOKIE_KEY);
    if (encryptF === undefined) {
      navigate('/debi-tool/login')
    }
  }, [navigate])
  return <div className="login-btn" style={LOGIN_FAILIED_STYLE}>{NO_ROLE_ERR} </div>;
};
export default NoRole;
